export const CORPORATE_SYSTEM_ADMIN = 'Corporate System Admin';

// "Facility (Company)", or "Corporate System Admin (Company)" for a corporate admin account.
// `account` is an entry of `getMyAccounts` / `getAvailableFacilitiesForEmployee`.
export const accountLabel = (account) => (account.company_name ? `${account.name} (${account.company_name})` : account.name);

// The same label for the account the user is logged into.
export const currentAccountLabel = (user) =>
  accountLabel({
    name: user.role === CORPORATE_SYSTEM_ADMIN ? CORPORATE_SYSTEM_ADMIN : user.facility?.name ?? '',
    company_name: user.company?.name,
  });
